import axios from "axios";

const API_URL = "https://chargeback-api.risco.pagar.me";
// const API_URL = "http://localhost:8080";

const buildApiPayload = function (companyId, files) {
  const transformedFiles = files.map((file) => {
    return {
      filename: file.name,
      file_extension: file.type,
      file_size: file.size,
    };
  });
  return {
    files: transformedFiles,
    company_id: companyId,
  };
};

export const verifyFiles = async function (companyId, files) {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/v1/representment/validate-batch/`,
      data: buildApiPayload(companyId, files),
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (e) {
    if (e.response.status === 422) {
      return {
        success: false,
        data: e.response.data,
      };
    }
    throw e;
  }
};

const buildMultipartPayload = function (companyId, files) {
  const formData = new FormData();
  formData.append("company_id", companyId);
  for (let file of files) {
    formData.append("files", file);
  }
  return formData;
};

export const processFiles = async function (companyId, files) {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/v1/representment/process-batch/`,
      data: buildMultipartPayload(companyId, files),
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
